/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

import { PublicClientApplication } from "@azure/msal-browser";
import axios from "axios";

(() => {
  // The initialize function must be run each time a new page is loaded
  Office.initialize = () => {

    const msalInstance = new PublicClientApplication({
        auth: {
          clientId: 'deb352bb-e12a-4dd1-a1b9-4ab17b0ce305',
          authority: 'https://login.microsoftonline.com/common',
          redirectUri: 'https://fileit.addin.paharpur.co.in/login.html' // Must be registered as "spa" type
        },
        cache: {
          cacheLocation: 'localStorage', // needed to avoid "login required" error
          storeAuthStateInCookie: true   // recommended to avoid certain IE/Edge issues
        }
      });

    // handleRedirectPromise should be invoked on every page load
    msalInstance.handleRedirectPromise()
        .then( async(response) => {
          if (response) {
            
                 Office.context.ui.messageParent( JSON.stringify({ status: 'success', result : response.accessToken }) );
            } else {
                // Otherwise, invoke login
                msalInstance.loginRedirect({
                    scopes: ['user.read']
                });
            }
        })
        .catch((error) => {
             // const errorData: string = `errorMessage: ${error.errorCode}
            //                        message: ${error.errorMessage}
            //                        errorCode: ${error.stack}`;
            const errorData: string = "you are not authorized person to access this File.it"
            Office.context.ui.messageParent( JSON.stringify({ status: 'failure', result: error }));
        });
  };
})();
